import { myApi } from '../../config/axiosConfig';

export const getRutas = async () => {
  try {
    const response = await myApi.get('/routes/saveRoutes'); // Asegúrate que exista este endpoint en tu backend
    return response.data;
  } catch (error) {
    console.error('❌ Error al obtener rutas:', error);
    return [];
  }
};
